import React from "react";

import settingsImg from "../../../resources/images/app/ui/setup.png";

export default function TableSettingsButton({ className, onClick, title="Настройки таблицы"}) {

    return (
        <div className={`setup-btn ${className}`} onClick={onClick} title={title}>
            <img src={settingsImg} alt=""/>
        </div>
    )
}
